import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  // Page layout, used by both compare pages
  page: {
    padding: theme.spacing(6)
  },
  header: {
    marginBottom: theme.spacing(4)
  },
  errorContainer: {
    padding: theme.spacing(6),
    maxWidth: 600
  },
  errorId: {
    marginTop: theme.spacing(2),
    wordBreak: 'break-all',
    color: theme.colors.text_secondary
  },
  noChanges: {
    marginTop: theme.spacing(4)
  },
  messageText: {
    display: 'block'
  },
  errorText: {
    color: theme.colors.error,
    alignItems: 'center',
    gap: theme.spacing(1)
  },

  // CompareHeaderMeta
  metaRow: {
    gap: theme.spacing(1)
  },
  subtitle: {
    marginRight: theme.spacing(1)
  },

  // OfferIdPairCard
  offerIdCard: {
    padding: theme.spacing(4, 6),
    margin: theme.spacing(6, 0)
  },
  offerIdPair: {
    width: 'auto'
  },
  offerIdBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1)
  },
  offerIdArrow: {
    padding: theme.spacing(0, 4)
  },
  offerDateLabel: {
    color: theme.colors.page__subtitle,
    fontSize: 14,
    textTransform: 'none'
  },
  offerIdKeyLabel: {
    marginTop: theme.spacing(2),
    marginBottom: 0,
    '& #value': {
      marginTop: 0
    }
  },

  // OfferDiffTable
  tableWrapper: {
    marginBottom: theme.spacing(3),
    backgroundColor: theme.colorPalette.white
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    fontFamily: 'monospace',
    fontSize: 13
  },
  th: {
    textAlign: 'left',
    padding: theme.spacing(2, 3),
    backgroundColor: theme.colorPalette.white,
    fontWeight: 600,
    borderBottom: `2px solid ${theme.colorPalette.green_75}`
  },
  td: {
    padding: theme.spacing(2, 3),
    verticalAlign: 'top',
    borderBottom: `1px solid ${theme.colorPalette.neutral_30}`,
    wordBreak: 'break-all',
    width: '50%'
  },
  tdPrevious: {
    backgroundColor: '#F7E7E6'
  },
  tdCurrent: {
    backgroundColor: '#E0F0E0'
  },
  fieldPath: {
    color: theme.colors.text_secondary
  },
  highlightPrevious: {
    background: 'rgba(192, 57, 43, 0.2)',
    borderRadius: 2,
    padding: '0 1px'
  },
  highlightCurrent: {
    background: 'rgba(0, 128, 0, 0.15)',
    borderRadius: 2,
    padding: '0 1px'
  },

  // Compare-to-parent page only
  previousChangesButton: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  },
  previousChangesArrow: {
    transform: 'scaleX(-1)'
  },
  switchModeButton: {
    marginTop: theme.spacing(2)
  },
  noParentCta: {
    marginTop: theme.spacing(6),
    width: 'auto'
  },

  // Arbitrary compare page only
  entryCard: {
    padding: theme.spacing(4, 6),
    margin: theme.spacing(6, 0)
  },
  entryPrompt: {
    marginBottom: theme.spacing(3)
  },
  entryRow: {
    gap: theme.spacing(4),
    flexWrap: 'nowrap'
  },
  entryField: {
    width: 320
  },
  compareButton: {
    width: 163,
    marginBottom: theme.spacing(7)
  },
  entryError: {
    marginTop: theme.spacing(2),
    color: theme.colors.error
  }
}));

export default useStyles;
